<ng-messages class="ng-messages" for="wbMessages.form[wbMessages.fieldName].$error" role="alert">
  <ng-messages-include src="{{::wbMessages.messagesSrc}}"></ng-messages-include>
</ng-messages>
<ng-messages class="ng-messages" ng-hide="wbMessages.form[wbMessages.fieldName].$invalid" for="wbMessages.server[wbMessages.fieldName]" role="alert">
  <ng-messages-include src="{{::wbMessages.messagesSrc}}"></ng-messages-include>
</ng-messages>
